module.exports = __webpack_public_path__ + "static/media/teacher29.e97c1878.png";